import * as THREE from 'three'
import { useMemo, useState } from 'react';

import { const_var, params } from '../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings, railLoftModel, railModel, roofBaseRailModel } from '../../../../../utils/Functions';
import { CSG } from '../../../../../assets/libs/csg-lib';
import { MaterialHighlightTruss, MaterialTruss } from '../../../CustomMaterial';

const LeftPorchLeg = ({leanToKey, isAction, angle, trimOffsetHeight, angleOffset, overlapTrussArr, setLeanToTrussPosArr, setLeftPorchLength, leftPorchLength, normalMap, envMap }) => {

    const [isEqualLeftHeight, setIsEqualLeftHeight] = useState(false);
    const [isEqualRightHeight, setIsEqualRightHeight] = useState(false);
    const [isEqualFrontHeight, setIsEqualFrontHeight] = useState(false);
    const [isEqualBackHeight, setIsEqualBackHeight] = useState(false);

    const railWidth = 0.2;
    const railHeight = 0.3;
    const edgeSlopeRailLength = 2;
    const edgeSlopeRailAlpha = Math.PI / 5.5;
    const cbFrontBackWallOffset = 0.16;

    const leanRoofLeftHeight = (params.b_l_t_r_p / 12) * params.lean_p_w;
    const leanRoofRightHeight = (params.b_l_t_r_pR / 12) * params.leanR_p_w;
    const leanRoofFrontHeight = (params.b_l_t_r_pF / 12) * params.leanF_p_w;
    const leanRoofBackHeight = (params.b_l_t_r_pB / 12) * params.leanB_p_w;
    const isEven = (i) => (i % 2 === 0);

    const roofRegularOffsetY = useMemo(() => (params.p_r_s === 1 ? const_var.roofRegularDst * 2 + 0.05 : 0), [params.p_r_s])
    
    const syncValues = useMemo(() => {
        let height, width, length, pitch, position, pos_z, compRotationY, leanToName, leanToSideName, legType, isLegTypeChanged, isRightPorch, isLeftPorch, isEqualHeight;
        if (leanToKey === 'front') {
            width = params.leanF_p_w;
            length = params.leanF_p_d;
            height = params.leanF_p_h;
            pitch = parseInt(params.b_l_t_r_pF);
            position = params.leanF_p_pos
            pos_z = params.p_d / 2
            compRotationY = 0
            leanToSideName = 'frontLeanSide'
            leanToName = 'frontlean'
            legType = const_var.leanFLegstype
            isLegTypeChanged = params.leanF_p_e_l;
            isLeftPorch = params.add_left_front_lean_porch
            isRightPorch = params.add_right_front_lean_porch
            isEqualHeight = isEqualFrontHeight

        } else if (leanToKey === 'back') {
            width = params.leanB_p_w;
            length = params.leanB_p_d;
            height = params.leanB_p_h;
            pitch = parseInt(params.b_l_t_r_pB);
            position = params.leanB_p_pos
            pos_z = params.p_d / 2
            compRotationY = Math.PI;
            leanToSideName = 'backLeanSide'
            leanToName = 'backlean'
            legType = const_var.leanBLegstype
            isLegTypeChanged = params.leanB_p_e_l
            isLeftPorch = params.add_right_back_lean_porch
            isRightPorch = params.add_left_back_lean_porch
            isEqualHeight = isEqualBackHeight
        } else if (leanToKey === 'left') {
            width = params.lean_p_w;
            length = params.lean_p_d;
            height = params.lean_p_h;
            pitch = parseInt(params.b_l_t_r_p);
            position = params.lean_p_pos
            pos_z = params.p_w / 2
            compRotationY = -Math.PI / 2
            leanToSideName = 'leftLeanSide'
            leanToName = 'leftlean'
            legType = const_var.leanLegstype
            isLegTypeChanged = params.lean_p_e_l;
            isLeftPorch = params.add_left_back_lean_porch
            isRightPorch = params.add_left_front_lean_porch
            isEqualHeight = isEqualLeftHeight
        } else if (leanToKey === 'right'){
            width = params.leanR_p_w;
            length = params.leanR_p_d;
            height = params.leanR_p_h;
            pitch = parseInt(params.b_l_t_r_pR);
            position = params.leanR_p_pos
            pos_z = params.p_w / 2
            compRotationY = Math.PI / 2
            leanToSideName = 'rightLeanSide'
            leanToName = 'rightlean'
            legType = const_var.leanRLegstype
            isLegTypeChanged = params.leanR_p_e_l
            isLeftPorch = params.add_right_front_lean_porch
            isRightPorch =params.add_right_back_lean_porch
            isEqualHeight = isEqualRightHeight
        } else {
            return null
        }
        
        return {width, length, height, pitch, position, pos_z, compRotationY, leanToSideName, leanToName, legType, isLegTypeChanged, isLeftPorch, isRightPorch, isEqualHeight}
    },[leanToKey, params.p_d, params.p_w, params.leanF_p_d, params.leanF_p_w, params.leanF_p_h, params.leanF_p_pos, params.b_l_t_r_pF, , params.leanB_p_d, params.leanB_p_w, params.leanB_p_h, params.leanB_p_pos, params.b_l_t_r_pB, params.leanR_p_d, params.leanR_p_w, params.leanR_p_h, params.leanR_p_pos, params.b_l_t_r_pR, params.lean_p_d, params.lean_p_w, params.lean_p_h, params.lean_p_pos, params.b_l_t_r_p, params.add_left_front_lean_porch, params.add_left_back_lean_porch, params.add_right_front_lean_porch, params.add_right_back_lean_porch,  params.lean_p_e_l, params.leanR_p_e_l, params.leanF_p_e_l, params.leanB_p_e_l, const_var.leanLegstype, const_var.leanRLegstype, const_var.leanFLegstype, const_var.leanBLegstype, isEqualRightHeight, isEqualLeftHeight, isEqualBackHeight, isEqualFrontHeight])

    const outInDistance = useMemo(() => {
        return (syncValues.legType === "double") ? 0.21 : 
       (syncValues.legType === "ladder") ? 0.5 : 
       (syncValues.legType === "zigzag") ? 1 : 0;
    }, [syncValues.legType]);

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    let count, distance;
    
    const initDistance = legDistance;
    const tempAvailableSize = syncValues.width - 0.22;
    const tempCount = Math.floor(tempAvailableSize / initDistance);

    if (tempAvailableSize === tempCount * initDistance) {
        count = tempCount;
        distance = initDistance;
    } else if (tempAvailableSize - tempCount * initDistance < initDistance / 2) {
        count = tempCount;
        distance = tempAvailableSize / count;
    } else {
        count = tempCount + 1;
        distance = tempAvailableSize / count;
    }

    const pillarRailDataArr = useMemo(() => {
        let dataInfoArray = [];
        let tempDataInfo
        
        for (let i = 1; (leanToKey === 'front' || leanToKey === 'back') ? i <= count : i < count; i++) {
            const pos_x = -(distance * i + syncValues.length / 2);
            tempDataInfo = ((leanToKey === 'front' || leanToKey === 'back') ?
            {
                    pos_x: pos_x,
                    outer_rail: {
                        alpha: (i === count ? -Math.PI / 4 : 0),
                        length: syncValues.height - railWidth / 4 + (params.p_r_s === 1 && -cbFrontBackWallOffset * 2 + 0.5),
                        pos_z: syncValues.pos_z + syncValues.width - railHeight / 2 + cbFrontBackWallOffset - (i === count ? 0.05 : 0),
                    },
                    inner_rail: {
                        pos_x: (i === count ? (pos_x + outInDistance) : pos_x),
                        alpha: (i === count ? -Math.PI / 4 : 0),
                        length: syncValues.height - railWidth / 4 + (params.p_r_s === 1 && -cbFrontBackWallOffset * 2 + 0.5),
                        pos_z: syncValues.pos_z + syncValues.width - railHeight / 2 + cbFrontBackWallOffset - (i === count ? 0.05 : 0) - outInDistance,
                    },
                    roof_rail: {
                        length: i === count ? 0 : Math.sqrt(Math.pow((syncValues.width - distance * i), 2) + Math.pow((syncValues.width - distance * i) * (syncValues.pitch / 12), 2)) - 0.2 + (params.p_r_s === 1 ? -0.35 : 0),
                        pos_y: syncValues.height + (syncValues.width - distance * i) * (syncValues.pitch / 12) - railWidth / 2 - (isAction ? 0.09 : 0.085) + roofRegularOffsetY,
                        pos_z: syncValues.pos_z + distance * i + 0.25,
                        alpha: -(Math.PI / 2 + Math.atan(syncValues.pitch / 12)),
                    },
                    slope_rail: {
                        length: edgeSlopeRailLength,
                        alpha: edgeSlopeRailAlpha,
                        alphaCorner: (i === count && -Math.PI / 4),
                        pos_x: pos_x + (i === count && 0.015),
                        pos_y: syncValues.height - (edgeSlopeRailLength * Math.cos(edgeSlopeRailAlpha) - (edgeSlopeRailLength * Math.sin(edgeSlopeRailAlpha)) * Math.tan(syncValues.pitch / 12)) - (i === count ? 0.05 : 0) - syncValues.pitch / 100 - 0.06 + roofRegularOffsetY,
                        pos_z: syncValues.pos_z + syncValues.width + railWidth - cbFrontBackWallOffset - 0.025 - (i === count ? 0.07 : 0),
                    },
                    loft_rail: {
                        length: railHeight,
                        visible: i === count ? false : true,
                        pos_x: pos_x - railHeight / 2,
                        pos_y: syncValues.height - railWidth / 4 - cbFrontBackWallOffset * 2 + 0.42,
                        pos_z: syncValues.pos_z + syncValues.width + cbFrontBackWallOffset - 0.05,
                    }
                }
                :
                {
                    pos_x: pos_x,
                    outer_rail: {
                        length: syncValues.height - railWidth / 4 + (params.p_r_s === 1 && -cbFrontBackWallOffset * 2 + 0.5),
                        pos_z: syncValues.pos_z + syncValues.width - railWidth + 0.05,
                    },
                    inner_rail: {
                        length: syncValues.height - railWidth / 4 + (params.p_r_s === 1 && -cbFrontBackWallOffset * 2 + 0.5),
                        pos_z: syncValues.pos_z+ syncValues.width - railWidth + 0.05 - outInDistance,
                    },
                    roof_rail: {
                        length: i === count ? 0 : Math.sqrt(Math.pow((syncValues.width - distance * i), 2) + Math.pow((syncValues.width - distance * i) * (syncValues.pitch / 12), 2)) + (params.p_r_s === 1 ? -0.35 : 0),
                        pos_y: syncValues.height + (syncValues.width - distance * i) * (syncValues.pitch / 12) - railWidth / 2 + (params.p_r_s === 1 ? -0.025 : -0.05) - (isAction ? 0.02: 0.01) + roofRegularOffsetY,
                        pos_z: syncValues.pos_z + distance * i - railWidth / 2,
                        alpha: -(Math.PI / 2 + Math.atan(syncValues.pitch / 12)),
                    },
                    slope_rail: {
                        length: edgeSlopeRailLength,
                        alpha: edgeSlopeRailAlpha,
                        pos_y: syncValues.height - (edgeSlopeRailLength * Math.cos(edgeSlopeRailAlpha) - (edgeSlopeRailLength * Math.sin(edgeSlopeRailAlpha)) * Math.tan(syncValues.pitch / 12)) - syncValues.pitch / 100 - 0.02 + roofRegularOffsetY,
                        pos_z: syncValues.pos_z + syncValues.width - cbFrontBackWallOffset,
                    },
                    loft_rail: {
                        length: railHeight,
                        visible: i === count ? false : true,
                        pos_x: pos_x - railHeight / 2,
                        pos_y: syncValues.height - railWidth / 4 - cbFrontBackWallOffset * 2 + 0.42,
                        pos_z: syncValues.pos_z + syncValues.width - 0.05,
                    }
                }
            )

            dataInfoArray.push(tempDataInfo);
        }
        
        return dataInfoArray;
    }, [syncValues.width, syncValues.length, syncValues.height, params.p_r_s, syncValues.pitch, legDistance, syncValues.pos_z, isAction, outInDistance, edgeSlopeRailAlpha, leanToKey, distance, count])

    const baseBottomRailDataArr = useMemo(() => {
        let dataInfoArray = [];

        const railData = {
            outer : {
                pos_x: -syncValues.length / 2 - syncValues.width + railWidth / 2,
                pos_y: railWidth / 2,
                pos_z: syncValues.pos_z + syncValues.width + cbFrontBackWallOffset - ((leanToKey === 'front' || leanToKey === 'back') ? (railHeight / 2) : (railHeight + 0.01)),
                length: syncValues.width,
            },
            inner : {
                pos_x: -syncValues.length / 2 - syncValues.width + railWidth / 2,
                pos_y: railWidth / 2,
                pos_z: syncValues.pos_z + syncValues.width + cbFrontBackWallOffset - outInDistance - ((leanToKey === 'front' || leanToKey === 'back') ?  (railHeight / 2) : (railHeight + 0.01)),
                length: syncValues.width,
            }
        }

        dataInfoArray.push(railData);

        return {dataInfoArray};
    }, [syncValues.pos_z, syncValues.length, syncValues.width, outInDistance, leanToKey])

    const roofPatternRailDataArr = useMemo(() => {
        let dataInfoArray = [];

        let count, distance, tempDataInfo;
        
        const initDistance = 3;
        const tempCount = Math.floor(syncValues.width / initDistance);
        if (syncValues.width === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (syncValues.width - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = syncValues.width / count;
        } else {
            count = tempCount + 1;
            distance = syncValues.width / count;
        }

        const initPosZ = 0.5
        const thickness = ((leanToKey === 'front' || leanToKey === 'back') ? ((2.5 - syncValues.pitch) * 0.045 / 4) : (syncValues.isEqualHeight ? 0.15 : 0.035))
        for (let i = 0; i < count; i++) {
            tempDataInfo = {
                pos_x: -syncValues.length / 2,
                pos_y: syncValues.height + (syncValues.width - distance * i - initPosZ) * (syncValues.pitch / 12) - thickness,
                pos_z: syncValues.pos_z + distance * i + initPosZ,
                length: distance * i + ((leanToKey === 'front' || leanToKey === 'back') ? 0.3 : 0.6),
                alpha: Math.atan(syncValues.pitch / 12),
            }

            dataInfoArray.push(tempDataInfo);
        }

        return dataInfoArray;
    }, [syncValues.pos_z, syncValues.height, syncValues.length, syncValues.pitch, syncValues.width, leanToKey, syncValues.isEqualHeight])

    const connectRailDataArr = useMemo(() => {
        let dataInfoArray = [];
        let count, distance;

        let initDistance = (syncValues.legType === 'zigzag') ? 1 : 2;
        const tempCount = Math.floor(syncValues.height / initDistance);

        if (syncValues.height === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (syncValues.height - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = syncValues.height / count;
        } else {
            count = tempCount + 1;
            distance = syncValues.height / count;
        }

        for (let i = 0; i < count; i++) {
            const length = ((i === 0) ? outInDistance : (outInDistance / Math.cos(Math.PI / 4)))
            const pos_z = syncValues.pos_z + syncValues.width - ((leanToKey === 'front' || leanToKey === 'back') ? (0) : (railHeight / 2)) - ((syncValues.legType === 'zigzag' || syncValues.legType === 'ladder') && (!isEven(i) ? outInDistance : 0));
            const pos_y = distance * i + railWidth / 2;
            const rotationX = Math.atan((distance) / outInDistance)

            const tempInfoObj = {
                pos_z : pos_z,
                pos_y : pos_y,
                length: (syncValues.legType === 'zigzag') ? length : outInDistance,
                rotationX: (syncValues.legType === 'zigzag') ? (isEven(i) ? (i === 0 ? Math.PI : (Math.PI / 2 + rotationX)) : rotationX) : (isEven(i) ? Math.PI : 0),
                distance: distance
            }

            dataInfoArray.push(tempInfoObj);
        }

        return dataInfoArray
    }, [syncValues.height, syncValues.width, syncValues.pos_z, outInDistance, syncValues.legType, leanToKey])

    const roofSlopeRailData = useMemo(() => {
        const railLength = Math.sqrt(Math.pow(syncValues.width, 2) + Math.pow(Math.sqrt(Math.pow(syncValues.width, 2) + Math.pow(syncValues.width * (syncValues.pitch / 12), 2)), 2)) - 0.3;
        const data = {
            pos_x: -(syncValues.length / 2 + railWidth / 4),
            pos_y: syncValues.height + syncValues.width * (syncValues.pitch / 12) - railHeight / 4 * 3,
            pos_z: syncValues.pos_z + 0.227,
            length: railLength,
            alpha: Math.PI / 2 - Math.acos((syncValues.width * syncValues.pitch / 12) / (railLength + 0.3)),
        }

        return data;
    }, [syncValues.pos_z, syncValues.height, syncValues.length, syncValues.pitch, syncValues.width])

    /************** cutting hole using CSG ***************/
    
    const delDoorModel = new THREE.Mesh(
        new THREE.ExtrudeGeometry(delModel(syncValues.leanToSideName, 'leg'), extrudeSettings(2)),
        new THREE.MeshStandardMaterial({ color: 'brown' })
    )
    const delDoorModel_Temp = delDoorModel.clone();
    delDoorModel_Temp.position.set(((leanToKey === 'front' || leanToKey === 'left') ? (-syncValues.position) : (syncValues.position)), 0, syncValues.pos_z + syncValues.width + cbFrontBackWallOffset - ((leanToKey === 'front' || leanToKey === 'right') ? (1.5) : (-0.5)));
    delDoorModel_Temp.rotateY(((leanToKey === 'front' || leanToKey === 'right') ? (0) : (Math.PI)))
    delDoorModel_Temp.updateMatrixWorld();

    const CSGPillarRailModelArr = useMemo(() => {
        let modelArr = [];
        let connectArr = []

        pillarRailDataArr.map((item, index) => {            
            const outerModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(railModel(railHeight, railWidth), extrudeSettings(item.outer_rail.length)),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            let outerModel_Temp = outerModel.clone();
            outerModel_Temp.rotateY(((leanToKey === 'front' || leanToKey === 'back') ? (item.outer_rail.alpha) : 0))
            outerModel_Temp.rotateX(-Math.PI / 2);
            outerModel_Temp.position.set(item.pos_x, 0, item.outer_rail.pos_z);
            outerModel_Temp.updateMatrixWorld();
            
            let innerModel_Temp = outerModel.clone();
            innerModel_Temp.rotateY(((leanToKey === 'front' || leanToKey === 'back') ? (item.outer_rail.alpha) : 0))
            innerModel_Temp.rotateX(-Math.PI / 2);
            innerModel_Temp.position.set(((leanToKey === 'front' || leanToKey === 'back') ? item.inner_rail.pos_x : item.pos_x), 0, item.inner_rail.pos_z);
            innerModel_Temp.updateMatrixWorld();

            const outerModel_Mesh_Temp = CSG.fromMesh(outerModel_Temp);
            const innerModel_Mesh_Temp = CSG.fromMesh(innerModel_Temp);
            const delDoorModel_Mesh_Temp = CSG.fromMesh(delDoorModel_Temp);

            const CSG_OuterModel_Temp = outerModel_Mesh_Temp.subtract(delDoorModel_Mesh_Temp);
            const CSG_InnerModel_Temp = innerModel_Mesh_Temp.subtract(delDoorModel_Mesh_Temp);
            
            const CSG_OuterModel = CSG.toMesh(
                CSG_OuterModel_Temp,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )
            const CSG_InnerModel = CSG.toMesh(
                CSG_InnerModel_Temp,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )

            connectRailDataArr.map((item_connect, index_connect) => {
                
                let connectRailLength = Math.sqrt(Math.pow(item_connect.distance, 2) + Math.pow((outInDistance * Math.sqrt(2)), 2)) - railWidth / 2
                let length = ((index === count - 1) ? (index_connect === 0 ? (outInDistance * Math.sqrt(2)) : (syncValues.legType === 'zigzag' ? connectRailLength : (outInDistance * Math.sqrt(2)))) : item_connect.length)
                let angleOffset = Math.atan((item_connect.distance) / ((outInDistance * Math.sqrt(2))))

                const meshConnectRailModel = new THREE.Mesh(
                    new THREE.ExtrudeGeometry(railModel(railHeight, railWidth), extrudeSettings(length)),
                    new THREE.MeshStandardMaterial({ color: 'pink' })
                )
                let meshConnectRailModel_Temp = meshConnectRailModel.clone();    
                meshConnectRailModel_Temp.position.set(item.pos_x - ((index === count - 1) ? (isEven(index_connect) ? -0.035 :  (-outInDistance + 0.04)) : 0), item_connect.pos_y, (index === count - 1) ? (isEven(index_connect) ? (item_connect.pos_z - railHeight / 4) : item_connect.pos_z) : item_connect.pos_z);
                meshConnectRailModel_Temp.rotateY((index === count - 1) ? (isEven(index_connect) ? Math.PI / 4 * 3 : -Math.PI / 4): 0)
                meshConnectRailModel_Temp.rotateX(syncValues.legType === 'zigzag' ? ((index === count - 1) ? (isEven(index_connect) ? (index_connect === 0 ? 0 : angleOffset) : (angleOffset)): item_connect.rotationX) : ((index === count - 1) ? 0 : (item_connect.rotationX)))
                meshConnectRailModel_Temp.updateMatrix();
                meshConnectRailModel_Temp.updateMatrixWorld();
                const meshConnectRailModel_CSG = CSG.fromMesh(meshConnectRailModel_Temp);
    
                const ConnectRailModel_CSG = meshConnectRailModel_CSG.subtract(delDoorModel_Mesh_Temp);
                const CSGConnectRailModel = CSG.toMesh(
                    ConnectRailModel_CSG,
                    new THREE.Matrix4(),
                    new THREE.MeshStandardMaterial({ color: 'blue' })
                )
                
                connectArr.push(CSGConnectRailModel.geometry)
                
                return null;
            })

            modelArr.push({
                outer : CSG_OuterModel.geometry,
                inner : CSG_InnerModel.geometry
            });
            
            return null;
        })
        
        return { modelArr, connectArr }
    }, [delDoorModel_Temp, pillarRailDataArr, connectRailDataArr, syncValues.legType, leanToKey])

    const CSGBottomRailModelArr = useMemo(() => {
        let modelArr = [];
        baseBottomRailDataArr.dataInfoArray.map((item) => {
            const trussModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(railModel(railWidth, railWidth), extrudeSettings(item.outer.length)),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            let outerModel_Temp = trussModel.clone();
            outerModel_Temp.rotateY(Math.PI / 2);
            outerModel_Temp.position.set(item.outer.pos_x, item.outer.pos_y, item.outer.pos_z);
            outerModel_Temp.updateMatrixWorld();
            
            let innerModel_Temp = trussModel.clone();
            innerModel_Temp.rotateY(Math.PI / 2);
            innerModel_Temp.position.set(item.inner.pos_x, item.inner.pos_y, item.inner.pos_z);
            innerModel_Temp.updateMatrixWorld();
    
            const outerModel_Mesh_Temp = CSG.fromMesh(outerModel_Temp);
            const innerModel_Mesh_Temp = CSG.fromMesh(innerModel_Temp);
            const outerDoorModel_Mesh_Temp = CSG.fromMesh(delDoorModel_Temp);
    
            const CSG_OuterModel_Temp = outerModel_Mesh_Temp.subtract(outerDoorModel_Mesh_Temp);
            const CSG_InnerModel_Temp = innerModel_Mesh_Temp.subtract(outerDoorModel_Mesh_Temp);
    
            const CSG_OuterModel = CSG.toMesh(
                CSG_OuterModel_Temp,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )
    
            const CSG_InnerModel = CSG.toMesh(
                CSG_InnerModel_Temp,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )
    
            modelArr.push({
                outer : CSG_OuterModel.geometry,
                inner : CSG_InnerModel.geometry
            });

            return null;
        })
        

        return  { modelArr };
        
    }, [baseBottomRailDataArr, delDoorModel_Temp])
    
    /************** ********************** ***************/

    const doorDataArr = useMemo(() => {
        let doorArr = []
        if (leanToKey === 'front') {
            doorArr = const_var.newDoorsArray.filter((item) => (item.userData.wallName === 'F_L_F_W' || item.userData.wallName === 'F_L_F_S_W'));
        } else if (leanToKey === 'back') {
            doorArr = const_var.newDoorsArray.filter((item) => (item.userData.wallName === 'B_L_S_W' || item.userData.wallName === 'B_L_F_S_W'))
        } else if (leanToKey === 'left') {
            doorArr = const_var.newDoorsArray.filter((item) => (item.userData.wallName === 'L_L_L_W' || item.userData.wallName === 'L_L_L_S_W'));
        } else if(leanToKey === 'right') {
            doorArr = const_var.newDoorsArray.filter((item) => (item.userData.wallName === 'R_L_R_W' || item.userData.wallName === 'R_L_R_S_W'));
        }

        return doorArr;
    }, [const_var.newDoorsArray, leanToKey]) 
    
    useMemo(() => {
        if(params.p_h === leanRoofLeftHeight + params.lean_p_h) setIsEqualLeftHeight(true)
        else setIsEqualLeftHeight(false)
        if(params.p_h === leanRoofRightHeight + params.leanR_p_h) setIsEqualRightHeight(true)
        else setIsEqualRightHeight(false)
        if(params.p_h === leanRoofFrontHeight + params.leanF_p_h) setIsEqualFrontHeight(true)
        else setIsEqualFrontHeight(false)
        if(params.p_h === leanRoofBackHeight + params.leanB_p_h) setIsEqualBackHeight(true)
            else setIsEqualBackHeight(false)
    
    }, [leanRoofFrontHeight, leanRoofLeftHeight, leanRoofRightHeight, leanRoofBackHeight, params.p_h, params.lean_p_h, params.leanR_p_h, params.leanF_p_h, params.leanB_p_h])

    useMemo(() => {
        let posArr = [];
        pillarRailDataArr.forEach((item) => {
            posArr.push(item.pos_x - ((leanToKey === 'front' || leanToKey === 'left') ? (-syncValues.position) : (syncValues.position)));
        });
    
        if (pillarRailDataArr.length > 0) {
            setLeftPorchLength(pillarRailDataArr.length);
    
            setLeanToTrussPosArr(prevArr => {
                const uniquePositions = new Set([...prevArr, ...posArr]);
                return Array.from(uniquePositions);
            });
        };
    }, [syncValues.isAddLeanTo, syncValues.position, syncValues.isLeftPorch, syncValues.isRightPorch, pillarRailDataArr, leanToKey, params.p_r_p]);

    return (
        <group name='left-porch-legs'>
            {CSGPillarRailModelArr.modelArr.map((item, index) =>
                <mesh name='outer-pillar-model' geometry={item.outer}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            )}

            {(syncValues.isLegTypeChanged == true && (syncValues.legType =="double" || syncValues.legType == "ladder" || syncValues.legType == "zigzag")) ? CSGPillarRailModelArr.modelArr.map((item, index) =>
                <mesh name='inner-pillar-model' geometry={item.inner}>
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            ) : null}
            {CSGBottomRailModelArr.modelArr.map((item) =>
                <mesh name='outer-bottom-model' geometry={item.outer}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            )}
            {(syncValues.isLegTypeChanged == true && (syncValues.legType =="double" || syncValues.legType == "ladder" || syncValues.legType == "zigzag")) ? CSGBottomRailModelArr.modelArr.map((item) =>
                <mesh name='inner-bottom-model' geometry={item.inner}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            ) : null}
            {(syncValues.isLegTypeChanged == true && (syncValues.legType == "ladder" || syncValues.legType == "zigzag")) ? CSGPillarRailModelArr.connectArr.map((item, index) =>
                <mesh  key={`connect-rail-${index}`} geometry={item}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            ) : null}

            {pillarRailDataArr.map((item, index) =>{
                let slope_rail_overlap = false;
                let isOverlap = false;
                if (!!overlapTrussArr && overlapTrussArr.buildingType === syncValues.leanToName && overlapTrussArr.idArr.includes(Math.abs(index-(leftPorchLength - 1)))) isOverlap = true;
                
                return(
                <group key={`pillar-pillar-rail-${index}`} name='pillar-pillar-rail-legs'>
                    {doorDataArr.map((item_door) => {                            
                        const sign = (leanToKey == "right" || leanToKey == "back") ? 1 : -1
                        if ((item_door.positionX - item_door.width / 2 + (syncValues.position*sign) < item.pos_x + railHeight / 2 &&
                            item_door.positionX + item_door.width / 2 + (syncValues.position*sign) >= item.pos_x - railHeight / 2 &&
                            item_door.positionY + item_door.height / 2 >= item.slope_rail.pos_y)
                        ) {
                            slope_rail_overlap = true;
                        } 
                        // else {
                        //     slope_rail_overlap = false;
                        // }
                        return null;
                    })}

                    {(!slope_rail_overlap && (leanToKey === 'front' || leanToKey === 'back')) &&
                        (<group name='edge-slope-rail-legs' position={[item.slope_rail.pos_x, item.slope_rail.pos_y - (isAction && (trimOffsetHeight - Math.tan(angle) * 0.2)), item.slope_rail.pos_z]} rotation={[0, item.slope_rail.alphaCorner, 0]}>
                            <group rotation={[-item.slope_rail.alpha, 0, 0]} name='edge-slope-rail-legs'>
                                <mesh rotation={[-Math.PI / 2, 0, 0]}>
                                    <extrudeGeometry args={[railModel(railHeight, railWidth), extrudeSettings(item.slope_rail.length - 0.15)]} />
                                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                                </mesh>
                            </group>
                        </group>)}
                    {(!slope_rail_overlap && (leanToKey === 'right' || leanToKey === 'left')) &&
                        (<group name='edge-slope-rail-legs' position={[item.pos_x, item.slope_rail.pos_y - (isAction && (trimOffsetHeight - Math.tan(angle) * 0.2)), item.slope_rail.pos_z]}>
                            <group rotation={[-item.slope_rail.alpha, 0, 0]} name='edge-slope-rail-legs'>
                                <mesh rotation={[-Math.PI / 2, 0, 0]}>
                                    <extrudeGeometry args={[railModel(railHeight, railWidth), extrudeSettings(item.slope_rail.length - 0.15)]} />
                                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                                </mesh>
                            </group>
                        </group>)
                    }

                    <group name='roof-legs' position={[item.pos_x, item.roof_rail.pos_y - (isAction && trimOffsetHeight), item.roof_rail.pos_z]} rotation={[-item.roof_rail.alpha, 0, 0]}>
                        {((leanToKey === 'front' || leanToKey === 'back') ? (index !== pillarRailDataArr.length - 1) : (index !== pillarRailDataArr.length)) &&
                            <mesh rotation={[-Math.PI / 2, 0, 0]}>
                                <extrudeGeometry args={[railModel(railHeight, railWidth), extrudeSettings(item.roof_rail.length)]} />
                                <MaterialTruss normalMap={normalMap} envMap={envMap} />
                            </mesh>
                        }
                    </group>
                    {params.p_r_s === 1 && item.loft_rail.visible &&
                        <mesh name='loft-rail-piece' position={[item.loft_rail.pos_x,item.loft_rail.pos_y, item.loft_rail.pos_z]} rotation={[0, Math.PI / 2, 0]}>
                            <extrudeGeometry args={[railLoftModel(railWidth, syncValues.pitch), extrudeSettings(railHeight)]} />
                            <meshPhongMaterial  color={"#F0F0F0"} map={normalMap} envMap={envMap} side={THREE.DoubleSide} reflectivity={0.4} />
                        </mesh>
                    }
                </group>
            )})}

            <group rotation={[angleOffset, 0, 0]}>
                {roofPatternRailDataArr.map((item, index) =>
                    params.p_r_s === 3 &&
                        <group key={`roof-base-rail-${index}`} name='roof-base-rail-legs' position={[item.pos_x, item.pos_y - (isAction && (trimOffsetHeight - Math.tan(angle) * 0.2)), item.pos_z]} rotation={[item.alpha, 0, 0]}>
                            <mesh rotation={[0, -Math.PI / 2, 0]}>
                                <extrudeGeometry args={[roofBaseRailModel(), extrudeSettings(item.length)]} />
                                <MaterialTruss normalMap={normalMap} envMap={envMap} />
                            </mesh>
                        </group>
                )}
            </group>
            {(leanToKey === 'front' || leanToKey === 'back') && 
                <group name='porch-corner-roof-truss' position={[roofSlopeRailData.pos_x, roofSlopeRailData.pos_y - (isAction && (trimOffsetHeight)) - 0.01 + roofRegularOffsetY, roofSlopeRailData.pos_z]} rotation={[0, -(Math.PI / 4), 0]}>
                    <mesh rotation={[roofSlopeRailData.alpha, 0, 0]}>
                        <extrudeGeometry args={[railModel(railHeight, railHeight), extrudeSettings(roofSlopeRailData.length - (params.p_r_s === 1 && 1))]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                </group>
            }
        </group>
    )}

export default LeftPorchLeg;